import { ElButton, ElDialog, ElMessage } from "element-plus";
import { ref } from "vue";
import { post_Json } from '@/jsUtils/nodejsRequest';
import { default_max_width } from "@/globalcfg.js";
export default {
  components: {
    ElButton,
    ElDialog
  },
  data() {
    return {
      // 下载pdf的提示图标
      dialogVisible: false,
      dialog_title: "download pdf",
      email_show: true,
      input: "",
      dialog_title: this.$t('messages.pdf_dialog_tile'),
      affix_offset: 0,
      pdf_dialog_font: "32px",
      but_height: "40px",
      dialog_width: "90%",
      bodyimg_height: "60vh",
      bodyimg_width: "100%",
      input_dict: this.$t('messages.pdf_input_dict'),
      // pdf文件获取的后台接口
      imageloadUrl: '/imageprocesshost' + '/showimages',
      //上传图片的接口

      isSending: false //是否正在发送邮件
    };
  },

  props: {
    // pdf文件的路径
    pdfimage: {
      type: String
    },
    // 图像数据
    pixelData: {
      type: Object,
      default: null
    },
    pdfimage_id: {
      type: String,
      default: ""
    },
    product_type: {
      type: String,
      default: ""
    }
  },
  watch: {
    pixelData: {
      handler: function (val, oldVal) {
        this.updateDialogBody();
      },
      deep: true
    },
    dialogVisible: {
      handler: function (val, oldVal) {
        if (val) {
          this.$nextTick(() => {
            this.scrollToInput();
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateDialogBody();
    });
    // this.updateDialogBody();

    window.addEventListener("resize", this.updateDialogBody);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateDialogBody);
  },
  methods: {
    opendownloadPdf() {
      this.dialogVisible = true;
    },
    scrollToInput() {
      // 获取 el-input 组件的实际 DOM 元素
      const inputEl = this.$refs.inputField.$el.querySelector('textarea');
      if (inputEl) {
        inputEl.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    // 根据图片的宽高比例，调整对话框的宽度和高度
    updateDialogBody() {
      if (this.pixelData == null) {
        return;
      }
      let img_width = this.pixelData.width;
      let img_height = this.pixelData.height;
      // let clientHeight = document.documentElement.clientHeight;
      // let clientWidth = document.documentElement.clientWidth;
      const clientWidth = window.innerWidth;
      const clientHeight = window.innerHeight;
      let height_rate = 0.6;
      let width_rate = 0.9;
      let aspectRatio = clientWidth / clientHeight;
      if (aspectRatio > 1.5) {
        // 宽屏
        width_rate = 0.5;
      } else if (aspectRatio > 0.9) {
        // 中等屏幕
        width_rate = 0.7;
      } else {
        // 高屏或手机
        width_rate = 0.85;
      }
      let img_ratio = img_width / img_height;
      let dialog_width = clientWidth * width_rate;
      let dialog_height = dialog_width / img_ratio;
      if (dialog_height > clientHeight * height_rate) {
        dialog_height = clientHeight * height_rate;
        dialog_width = dialog_height * img_ratio;
      }
      this.dialog_width = `${dialog_width.toString()}px`;
    },
    async onConfirm() {
      let email = this.input;
      let self = this;
      this.isSending = true;

      // 进行合法性检查
      if (email == "") {
        ElMessage({
          showClose: true,
          message: this.$t('messages.pdf_email_blank'),
          duration: 3000,
          type: "warning",
          customClass: 'custom-message'
        });
        this.isSending = false;
        return;
      }
      // 如果email没有@符号
      if (email.indexOf("@") == -1) {
        ElMessage({
          showClose: true,
          message: this.$t('messages.pdf_email_invalid'),
          type: "warning",
          customClass: "custom-message"
        });
        this.isSending = false;
        return;
      }

      // 发送pdf文件到邮箱
      // console.dir(this.pixelData);

      let QRCode = sessionStorage.getItem("verifySuccessfully");
      if (QRCode == null) {
        QRCode = "DefaultQRCode";
      }
      let postdata = {
        emailaddr: email,
        pdfimage_id: this.pdfimage_id,
        product_type: this.product_type
      };
      let requesturl = this.imageloadUrl;
      try {
        const response = await fetch(requesturl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(postdata)
        });
        const data = await response.json();
        if (data && data.encode == 200 || data.code == 200) {
          ElMessage({
            showClose: true,
            message: this.$t('messages.pdf_email_send'),
            duration: 5000,
            type: "success",
            customClass: "custom-message"
          });
          this.dialogVisible = false;
          return;
        }
      } catch (error) {
        // console.error('failed to get pdf: ', error);
      } finally {
        this.isSending = false;
      }
    },
    showDialog() {
      this.updateDialogBody();
      this.dialogVisible = true;
    }
  }
};